export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 2,
    "title": "What unsupervised learning algorithm can be used for clustering?",
    "description": "K-means"
  },
  {
    "id": 2,
    "topic_id": 2,
    "title": "What AWS service is best suited to build generative AI applications?",
    "description": "Amazon Bedrock"
  },
  {
    "id": 3,
    "topic_id": 2,
    "title": "While evaluating the performance of your machine learning model what does accuracy measure?",
    "description": "The proportion of correct predictions (positive and negative) made by a model out of all the predictions."
  },
  {
    "id": 4,
    "topic_id": 2,
    "title": "In a neural network weights are considered hyperparameters. True or false?",
    "description": "False"
  },
  {
    "id": 5,
    "topic_id": 2,
    "title": "In unsupervised machine learning training data has no labels. True or false?",
    "description": "True"
  },
  {
    "id": 6,
    "topic_id": 2,
    "title": "What problem does L1 regularization address?",
    "description": "Overfitting"
  },
  {
    "id": 7,
    "topic_id": 2,
    "title": "What does the loss function measure in a machine learning model?",
    "description": "The difference between a model’s predicted output and the actual target value."
  },
  {
    "id": 8,
    "topic_id": 2,
    "title": "What’s the most suited AWS service to address bias and explainability in machine learning models?",
    "description": "Amazon SageMaker Clarify"
  },
  {
    "id": 9,
    "topic_id": 2,
    "title": "What’s the first phase of the machine learning lifecycle?",
    "description": "Define the machine learning problem"
  },
  {
    "id": 10,
    "topic_id": 1,
    "title": "Which AWS storage service is best suited to serve your machine learning algorithm large datasets with low latency and high throughput from a high-performance file system?",
    "description": "Amazon FSx for Lustre"
  },
  {
    "id": 11,
    "topic_id": 3,
    "title": "EC2 p5 instance types support GPU compute capabilities. True or false?",
    "description": "True"
  },
  {
    "id": 12,
    "topic_id": 2,
    "title": "Which algorithms allow you to perform topic modeling tasks using Amazon SageMaker AI?",
    "description": "Latent Dirichlet Allocation (LDA), Neural Topic Model (NTM)"
  },
  {
    "id": 13,
    "topic_id": 1,
    "title": "In a machine learning model features are the input to the model. True or false?",
    "description": "True"
  },
  {
    "id": 14,
    "topic_id": 1,
    "title": "In machine learning when does data leakage occur?",
    "description": "When test data “leaks” into the training dataset, impacting the model’s ability to generalize to new, unseen data."
  },
  {
    "id": 15,
    "topic_id": 1,
    "title": "What AWS service simplifies the process of labeling your machine learning dataset?",
    "description": "Amazon SageMaker Ground Truth"
  },
  {
    "id": 16,
    "topic_id": 1,
    "title": "What AWS service simplifies the process of splitting your machine learning dataset?",
    "description": "Amazon SageMaker Data Wrangler"
  },
  {
    "id": 17,
    "topic_id": 1,
    "title": "What problem does oversampling address?",
    "description": "Class Imbalance"
  },
  {
    "id": 18,
    "topic_id": 1,
    "title": "In machine learning data augmentation involves the collection of new data. True or false?",
    "description": "False"
  },
  {
    "id": 19,
    "topic_id": 1,
    "title": "In feature engineering what is a facet?",
    "description": "A specific feature that can be used for analysis (e.g., bias), feature selection, or transformation."
  },
  {
    "id": 20,
    "topic_id": 2,
    "title": "What is cross-validation’s main goal?",
    "description": "Evaluate a machine learning model’s performance to ensure it generalizes well to new, unseen data."
  },
  {
    "id": 21,
    "topic_id": 2,
    "title": "What is retrieval augmented generation (RAG)?",
    "description": "A technique that enhances the capabilities of a large language model (LLM) by allowing it to access and reference external knowledge sources before generating responses."
  },
  {
    "id": 22,
    "topic_id": 3,
    "title": "What is a production variant in the model deployment phase of the machine learning lifecycle?",
    "description": "A specific configuration of a model version that is deployed as part of an endpoint in a production environment."
  },
  {
    "id": 23,
    "topic_id": 1,
    "title": "A JavaScript Object Notation (JSON) file is an example of semi-structured data. True or false?",
    "description": "True"
  },
  {
    "id": 24,
    "topic_id": 2,
    "title": "What algorithm is best suited for time-series forecasting with Amazon SageMaker AI?",
    "description": "DeepAR"
  },
  {
    "id": 25,
    "topic_id": 4,
    "title": "With Amazon Bedrock what is the unit of billing?",
    "description": "For text-generation models the unit of billing is based on input and output tokens. For image-generation models (like Amazon Nova Canvas) the unit of billing is based on the number of images generated."
  },
  {
    "id": 26,
    "topic_id": 3,
    "title": "What model deployment type is best suited for unpredictable volume of inference requests?",
    "description": "Serverless Inference"
  },
  {
    "id": 27,
    "topic_id": 3,
    "title": "What model deployment strategy offers the right balance between rollout time and risk mitigation?",
    "description": "Canary Deployment"
  },
  {
    "id": 28,
    "topic_id": 2,
    "title": "What does precision measure during model evaluation?",
    "description": "The proportion of correct positive predictions made by a model out of all the predictions it classified as positive."
  },
  {
    "id": 29,
    "topic_id": 1,
    "title": "What algorithm is best suited to minimize the number of features in a dataset while preserving the relevant relationships in the data?",
    "description": "Principal Component Analysis (PCA)"
  },
  {
    "id": 30,
    "topic_id": 1,
    "title": "Which Amazon SageMaker AI service offers a low-code solution to time-series data processing?",
    "description": "Amazon SageMaker Data Wrangler"
  },
  {
    "id": 31,
    "topic_id": 1,
    "title": "What is one-hot encoding?",
    "description": "A technique to convert categorical data into numerical data, where each category is represented by a unique binary vector."
  },
  {
    "id": 32,
    "topic_id": 2,
    "title": "What is Bayesian search?",
    "description": "An optimization method used to intelligently explore the hyperparameter space of a machine learning model, and quickly converge towards the best configuration."
  },
  {
    "id": 33,
    "topic_id": 2,
    "title": "What’s the elbow method?",
    "description": "A technique used to determine the optimal number of clusters in a clustering algorithm, such as K-means."
  },
  {
    "id": 34,
    "topic_id": 2,
    "title": "The Linear Learner built-in algorithm supports only classification machine learning problems. True or false?",
    "description": "False"
  },
  {
    "id": 35,
    "topic_id": 3,
    "title": "What is model deployment in Amazon SageMaker AI?",
    "description": "The process of making a trained model available to serve inference"
  },
  {
    "id": 36,
    "topic_id": 2,
    "title": "When does a machine learning model overfit its dataset?",
    "description": "When it learns the noise and specific details of the training data to the extent that it performs exceptionally well on the training data, but poorly on new, unseen data."
  },
  {
    "id": 37,
    "topic_id": 1,
    "title": "When is a dataset considered to have high dimensionality?",
    "description": "When it contains a large number of features (or dimensions)."
  },
  {
    "id": 38,
    "topic_id": 2,
    "title": "How does L2 (Ridge) regularization address overfitting?",
    "description": "By adding a penalty term to the loss function based on the squared magnitude of the model’s coefficients."
  },
  {
    "id": 39,
    "topic_id": 2,
    "title": "What capabilities are provided by the Estimator class with the SageMaker Python SDK?",
    "description": "The Estimator class provides a high-level interface for defining, configuring, and managing training jobs and model deployment."
  },
  {
    "id": 40,
    "topic_id": 2,
    "title": "What is an epoch?",
    "description": "A single complete pass through the entire training dataset during the model training process."
  },
  {
    "id": 41,
    "topic_id": 2,
    "title": "How does Gradient Descent optimization help improve the performance of a machine learning model?",
    "description": "By iteratively adjusting the model’s parameters to minimize the loss function."
  },
  {
    "id": 42,
    "topic_id": 2,
    "title": "Your model’s performance metric (e.g., accuracy) is significantly lower on the test dataset compared to the training dataset. What does this indicate, and what steps can you take to address it?",
    "description": "This indicates overfitting. Steps to address it include:\nUsing cross-validation\nAdding regularization\nEmploying data augmentation\nSimplifying the model\nUsing techniques like dropout"
  },
  {
    "id": 43,
    "topic_id": 1,
    "title": "You are working with imbalanced datasets where one class is significantly underrepresented. What techniques and AWS services can you use to handle class imbalance during model training?",
    "description": "You can use Amazon SageMaker Data Wrangler and techniques such as oversampling the minority class, undersampling the majority class, or use synthetic data generation methods like SMOTE."
  },
  {
    "id": 44,
    "topic_id": 1,
    "title": "You have multiple features that are highly correlated with each other in your dataset. What are the potential issues, and how can you address them?",
    "description": "Highly correlated features can lead to multicollinearity, which can affect model performance.\nAddress them by using dimensionality reduction techniques like PCA, or removing one of the correlated features."
  },
  {
    "id": 45,
    "topic_id": 1,
    "title": "During model development, you observe that certain features have different scales. What preprocessing step can you take to ensure your model treats all features equally?",
    "description": "You can standardize or normalize the features to ensure they are on the same scale, using techniques like Min-Max scaling or Z-score normalization."
  },
  {
    "id": 46,
    "topic_id": 2,
    "title": "You need to choose an evaluation metric for a binary classification problem. What factors should you consider, and what are some common metrics you can use?",
    "description": "Consider the problem context and consequences of false positives/negatives. Common metrics include accuracy, precision, recall, F1 score, and AUC-ROC."
  },
  {
    "id": 47,
    "topic_id": 4,
    "title": "After deploying a model, you need to monitor its performance in production. What approaches can you take to ensure the model remains accurate and reliable over time?",
    "description": "Leverage Amazon SageMaker Model Monitor for tracking metrics like accuracy, precision, recall, and AUC-ROC.\nUse Amazon CloudWatch to set up alerts and automate retraining with new data when model drift is detected."
  },
  {
    "id": 48,
    "topic_id": 2,
    "title": "You are using cross-validation to evaluate your model. What is the purpose of cross-validation, and how does it help in model development?",
    "description": "Cross-validation evaluates the model’s ability to generalize to new data by partitioning the dataset into multiple training and validation sets.\nEach partition is called a fold, and the dataset is split into k folds.\nThe model is trained and validated k times, with each fold used once as the validation set.\nThis process provides reliable performance estimates and helps in preventing overfitting."
  },
  {
    "id": 49,
    "topic_id": 1,
    "title": "You need to preprocess your dataset that contains a mix of numerical and categorical features before training your model. What services or methods can you use in Amazon SageMaker AI to accomplish this?",
    "description": "Use Amazon SageMaker Data Wrangler for visual data preprocessing, or write custom preprocessing scripts using Python and the pandas library."
  },
  {
    "id": 50,
    "topic_id": 2,
    "title": "Your model is trained on Amazon SageMaker AI but requires hyperparameter tuning to improve performance. What feature does Amazon SageMaker AI provide to automate this process?",
    "description": "Use Automatic Model Tuning (AMT) with Amazon SageMaker AI, which uses Bayesian optimization to find the optimal hyperparameters by searching through a defined range of values."
  },
  {
    "id": 51,
    "topic_id": 2,
    "title": "You want to train a deep learning model with multiple GPUs to speed up the training process. How can you configure Amazon SageMaker AI to support this use case?",
    "description": "Specify a training job with a multi-GPU instance type (e.g., p4d.24xlarge).\nUse the SageMaker Estimator class to define the number of instances and GPUs."
  },
  {
    "id": 52,
    "topic_id": 3,
    "title": "You have a trained model and now need to deploy it for real-time predictions. What are the steps to deploy a model in Amazon SageMaker AI?",
    "description": "Use the deploy method of the SageMaker Estimator class to create a SageMaker endpoint for real-time inference.\nConfigure the endpoint with the desired instance type and count."
  },
  {
    "id": 53,
    "topic_id": 4,
    "title": "After deployment, you need to monitor the performance of your model in production. What services or techniques does Amazon SageMaker AI provide to achieve this?",
    "description": "Use Amazon SageMaker Model Monitor to continuously monitor model performance, detect data quality issues, and track model accuracy over time."
  },
  {
    "id": 54,
    "topic_id": 1,
    "title": "Your training data is stored in Amazon S3, and you want to train a model in Amazon SageMaker AI using this data. How can you specify the data source programmatically?",
    "description": "Use the fit method of the SageMaker Estimator class and specify the S3 URI of the training data as input."
  },
  {
    "id": 55,
    "topic_id": 3,
    "title": "You need to run a batch inference job on a large dataset using your trained model. What feature of Amazon SageMaker AI allows you to perform batch predictions?",
    "description": "Use Amazon SageMaker Batch Transform to perform batch inference. Create a transform job and specify the input data, model, and output location."
  },
  {
    "id": 56,
    "topic_id": 2,
    "title": "Your model requires fine-tuning using additional data and training epochs. How can you continue training a pre-trained model in Amazon SageMaker AI?",
    "description": "Load the pre-trained model artifacts and continue training using the SageMaker Estimator class, specifying the additional data and hyperparameters."
  },
  {
    "id": 57,
    "topic_id": 2,
    "title": "You need to explain the predictions made by your model to stakeholders. What techniques can you use in Amazon SageMaker AI to make the model’s predictions interpretable?",
    "description": "Use interpretability tools like SHAP (SHapley Additive exPlanations) in Amazon SageMaker Notebooks to explain model predictions."
  },
  {
    "id": 58,
    "topic_id": 2,
    "title": "You are working with a time-series dataset and need to forecast future values. Which Amazon SageMaker AI built-in algorithm is well-suited for this task?",
    "description": "Use the Amazon SageMaker AI DeepAR algorithm, designed for time-series forecasting and capable of modeling complex patterns in the data."
  },
  {
    "id": 59,
    "topic_id": 2,
    "title": "You want to train a machine learning model using a large dataset stored in an Amazon S3 bucket. Explain the steps to configure and start a training job in Amazon SageMaker AI.",
    "description": "Upload the dataset to an S3 bucket.\nCreate a training job definition including the S3 path.\nChoose a training algorithm.\nConfigure the training instance type and count.\nSpecify hyperparameters.\nStart the training job using the Amazon SageMaker AI console or SDK."
  },
  {
    "id": 60,
    "topic_id": 1,
    "title": "How do you handle imbalanced datasets in Amazon SageMaker AI when building a classification model?",
    "description": "Use Amazon SageMaker Data Wrangler and techniques such as oversampling minority class, undersampling majority class, and using algorithms like SMOTE (Synthetic Minority Over-sampling Technique) or XGBoost with built-in support for class imbalance."
  },
  {
    "id": 61,
    "topic_id": 3,
    "title": "You need to deploy a trained model to a real-time endpoint. Describe the process using the SageMaker Python SDK.",
    "description": "Create a model object by specifying the location of the trained model artifacts in S3.\nConfigure an endpoint configuration object specifying the instance type.\nDeploy the model by creating a real-time endpoint."
  },
  {
    "id": 62,
    "topic_id": 3,
    "title": "Your deployed model’s predictions are slowing down due to high traffic. What steps can you take in Amazon SageMaker AI to address this issue?",
    "description": "Scale the endpoint by adding more instances or upgrading to more powerful instance types.\nAdditionally, implement endpoint autoscaling policies to automatically adjust the number of instances based on demand."
  },
  {
    "id": 63,
    "topic_id": 2,
    "title": "Describe how you would use Amazon SageMaker Experiments to track and compare multiple machine learning experiments.",
    "description": "Create an experiment, log each run with associated metadata (e.g., hyperparameters, metrics, and artifacts).\nUse the Amazon SageMaker Experiments API or console to visualize and compare the results of different runs."
  },
  {
    "id": 64,
    "topic_id": 2,
    "title": "Explain the process of hyperparameter tuning in Amazon SageMaker AI using Automatic Model Tuning (AMT).",
    "description": "Define a tuning job specifying the range of hyperparameters.\nSelect a strategy (e.g., random, Bayesian optimization).\nSpecify the training jobs to run with different hyperparameter combinations.\nEvaluate the performance to find the best hyperparameters."
  },
  {
    "id": 65,
    "topic_id": 2,
    "title": "How can you debug and troubleshoot issues with a training job in Amazon SageMaker AI?",
    "description": "Enable Amazon SageMaker Debugger, which provides real-time insights by collecting and analyzing training data.\nUse built-in rules to detect issues.\nVisualize the logs and metrics to pinpoint and resolve the issues."
  },
  {
    "id": 66,
    "topic_id": 4,
    "title": "You have a dataset with sensitive information. How can you ensure data security and privacy in Amazon SageMaker AI?",
    "description": "Use encryption for data at rest and in transit.\nEmploy AWS Identity and Access Management (IAM) for access control.\nEnable VPC endpoints for secure communication.\nUse Amazon Macie to detect sensitive data."
  },
  {
    "id": 67,
    "topic_id": 4,
    "title": "How do you set up baseline constraints and statistics for a model using Amazon SageMaker Model Monitor?",
    "description": "Analyze the training dataset to generate baseline statistics and constraints.\nSave the generated baseline to Amazon S3.\nConfigure a monitoring schedule to compare real-time data against the baseline."
  },
  {
    "id": 68,
    "topic_id": 4,
    "title": "Your model’s predictions have started showing unexpected results. How can you debug this using Amazon SageMaker Model Monitor?",
    "description": "Set up data capture to record real-time input and output data.\nCompare this data against baseline statistics to identify anomalies.\nUse captured data for further analysis and debugging."
  },
  {
    "id": 69,
    "topic_id": 4,
    "title": "Describe how you can monitor model biases in Amazon SageMaker AI.",
    "description": "Utilize Amazon SageMaker Clarify, which can analyze both pre- and post-training datasets to identify potential biases in features and predictions.\nGenerate fairness reports."
  },
  {
    "id": 70,
    "topic_id": 4,
    "title": "How do you ensure that your model monitoring configurations are secure and accessible only by authorized personnel?",
    "description": "Use AWS Identity and Access Management (IAM) policies to control access, encrypt monitoring data at rest using AWS Key Management Service (KMS), and configure Amazon VPC endpoints to securely access SageMaker APIs."
  },
  {
    "id": 71,
    "topic_id": 4,
    "title": "Explain how to customize monitoring schedules and alerts in Amazon SageMaker Model Monitor.",
    "description": "Define a monitoring schedule specifying the frequency of evaluations.\nConfigure Amazon CloudWatch alarms to trigger notifications based on specific conditions.\nSet up email or SMS alerts using Amazon Simple Notification Service (SNS)."
  },
  {
    "id": 72,
    "topic_id": 4,
    "title": "Your model is deployed in multiple regions. How can you achieve consistent monitoring across all regions?",
    "description": "Use Amazon SageMaker Model Monitor with multiregion data capture configurations.\nReplicate monitoring schedule.\nCentralize monitoring data into a single S3 bucket or data lake for unified analysis."
  },
  {
    "id": 73,
    "topic_id": 4,
    "title": "Describe how Amazon SageMaker Model Monitor can help in detecting concept drift.",
    "description": "Amazon SageMaker ModelMonitor configures baseline constraints and captures real-time data.\nIt also regularly compares new data distributions with baseline statistics to identify shifts in data patterns, indicating potential concept drift."
  },
  {
    "id": 74,
    "topic_id": 4,
    "title": "What is the role of Amazon SageMaker Clarify’s drift detection feature, and how do you set it up?",
    "description": "Amazon SageMaker Clarify’s drift detection identifies shifts in data or model performance that may indicate degradation.\nSet it up by specifying baseline data, configuring detection parameters, and scheduling periodic evaluations."
  },
  {
    "id": 75,
    "topic_id": 3,
    "title": "How can you automate model retraining and redeployment based on monitoring results in Amazon SageMaker AI?",
    "description": "Integrate Amazon SageMaker Model Monitor with AWS Step Functions to orchestrate workflows that trigger retraining and redeployment processes when monitoring results indicate performance degradation or data drift."
  },
  {
    "id": 76,
    "topic_id": 1,
    "title": "Your dataset has a mix of categorical and numerical features. Explain how you would prepare these features for a machine learning model in Amazon SageMaker AI.",
    "description": "Use one-hot encoding or label encoding for categorical features and normalization or standardization for numerical features. These preprocessing steps can be applied using Amazon SageMaker Data Wrangler."
  },
  {
    "id": 77,
    "topic_id": 1,
    "title": "Describe how to create new features from existing time series data using Amazon SageMaker AI.",
    "description": "Use Amazon SageMaker Data Wrangler to create lag features, rolling averages, or extract time-based components (e.g., day of the week, month). This enriches the dataset with relevant temporal information."
  },
  {
    "id": 78,
    "topic_id": 1,
    "title": "How can you detect and remove outliers in your dataset using Amazon SageMaker AI?",
    "description": "Implement an outlier detection algorithm (e.g., Z-score, IQR) in a Processing Job or Amazon SageMaker Data Wrangler.\nRemove or treat outliers based on the detected values to improve model robustness."
  },
  {
    "id": 79,
    "topic_id": 1,
    "title": "Your model’s performance is suffering due to multicollinearity among features. What steps can you take using Amazon SageMaker AI to address this issue?",
    "description": "Use Amazon SageMaker Processing Jobs to calculate correlation matrix, identify highly correlated features, and either remove them or use algorithms like Principal Component Analysis (PCA) to reduce dimensionality."
  },
  {
    "id": 80,
    "topic_id": 2,
    "title": "How can Amazon SageMaker Clarify assist in understanding feature importance for a model?",
    "description": "Use Amazon SageMaker Clarify to compute feature importance scores, which indicate the impact of each feature on model predictions. This helps in identifying key features and potentially eliminating redundant ones."
  },
  {
    "id": 81,
    "topic_id": 2,
    "title": "How can you automate the feature engineering process in Amazon SageMaker AI for iterative model development?",
    "description": "Combine Amazon SageMaker Pipelines with feature engineering steps in Processing Jobs or Amazon SageMaker Data Wrangler. This enables automated and repeatable feature engineering workflows that can be reused in different iterations of model development."
  },
  {
    "id": 82,
    "topic_id": 1,
    "title": "Your dataset has a feature with a significant number of missing values. Explain how you would handle these missing values in Amazon SageMaker AI before training your model.",
    "description": "Use Amazon SageMaker Data Wrangler to impute missing values, by filling them with mean/median/mode."
  },
  {
    "id": 83,
    "topic_id": 1,
    "title": "You are dealing with a dataset containing numerical features with different scales. How would you normalize these features using Amazon SageMaker AI?",
    "description": "Use Amazon Data Wrangler or SKLearnProcessor to apply feature scaling techniques like Min-Max scaling or Standard scaling to normalize the features."
  },
  {
    "id": 84,
    "topic_id": 1,
    "title": "Your dataset includes text features that need to be transformed into numerical representations. What steps would you take in Amazon SageMaker AI to achieve this?",
    "description": "Use the BlazingText algorithm or TextFeaturizer in Amazon SageMaker AI to convert text features into numerical vectors using techniques like Word2Vec embeddings."
  },
  {
    "id": 85,
    "topic_id": 1,
    "title": "You are working with time-series data that has datetime features. How would you extract useful features from these datetime columns in Amazon SageMaker AI?",
    "description": "Use Amazon SageMaker Data Wrangler or custom preprocessing scripts to extract features such as day, month, year, day of the week, hour, and time intervals from the datetime columns."
  },
  {
    "id": 86,
    "topic_id": 1,
    "title": "Describe how you would use feature engineering techniques to handle highly imbalanced classes in a classification problem with Amazon SageMaker AI.",
    "description": "Use Amazon SageMaker Data Wrangler to apply techniques like SMOTE (Synthetic Minority Over-sampling Technique), resampling, or creating custom features that better separate the classes."
  },
  {
    "id": 87,
    "topic_id": 1,
    "title": "Which service in Amazon SageMaker AI allows you to store and retrieve feature data?",
    "description": "Amazon SageMaker Feature Store"
  },
  {
    "id": 88,
    "topic_id": 3,
    "title": "What service simplifies the automation of machine learning workflows in Amazon SageMaker AI?",
    "description": "Amazon SageMaker Pipelines"
  },
  {
    "id": 89,
    "topic_id": 3,
    "title": "What Amazon SageMaker AI service allows you to process large datasets in batches for inference?",
    "description": "Amazon SageMaker Batch Transform"
  },
  {
    "id": 90,
    "topic_id": 2,
    "title": "What is a foundation model?",
    "description": "A large AI model that’s trained on massive amounts of data. Amazon Bedrock allows to use foundation models from leading AI companies."
  },
  {
    "id": 91,
    "topic_id": 3,
    "title": "Amazon Bedrock allows you to integrate foundation models into your applications. True or false?",
    "description": "True"
  },
  {
    "id": 92,
    "topic_id": 1,
    "title": "What is the purpose of Amazon Polly?",
    "description": "Amazon Polly converts text into speech."
  },
  {
    "id": 93,
    "topic_id": 1,
    "title": "What is the purpose of Amazon Transcribe?",
    "description": "Amazon Transcribe converts speech into text, enabling automatic transcription of audio files."
  },
  {
    "id": 94,
    "topic_id": 2,
    "title": "How does Amazon Lex enhance applications?",
    "description": "Amazon Lex builds conversational interfaces using voice and text, enabling chatbots and voice assistants."
  },
  {
    "id": 95,
    "topic_id": 1,
    "title": "What is Amazon Personalize used for?",
    "description": "Amazon Personalize provides personalized recommendations for users based on their behavior."
  },
  {
    "id": 96,
    "topic_id": 1,
    "title": "Amazon Rekognition can detect faces in images. True or false?",
    "description": "True"
  },
  {
    "id": 97,
    "topic_id": 4,
    "title": "Amazon Translate cannot handle real-time translation of text. True or false?",
    "description": "False"
  },
  {
    "id": 98,
    "topic_id": 4,
    "title": "Database Administrator is an ML persona in Amazon SageMaker Role Manager. True or false?",
    "description": "False"
  },
  {
    "id": 99,
    "topic_id": 1,
    "title": "The AVRO data format supports columnar data. True or false?",
    "description": "False"
  },
  {
    "id": 100,
    "topic_id": 1,
    "title": "Which AWS storage service provides extremely quick and efficient access to large training datasets for machine learning models?",
    "description": "Amazon FSx for Lustre"
  },
  {
    "id": 101,
    "topic_id": 200,
    "title": "Know the difference between data, information, and knowledge.",
    "description": "Data is a collection of raw, unprocessed facts and figures without context or meaning. Information is data that has been processed, interpreted, and given context, making it useful for decision-making. Information is characterized by accuracy, relevance, completeness, and timeliness. Knowledge is information that has been assimilated, understood, and interpreted through experience, leading to insights, wisdom, or expertise."
  },
  {
    "id": 102,
    "topic_id": 200,
    "title": "Know the difference between structured, semi-structured, and unstructured data.",
    "description": "Structured data is organized in accordance to a predefined schema and is easily searchable. Examples include Excel files and relational databases. Semi-structured data does not conform to a strict schema but still contains tags or markers to separate semantic elements, providing a degree of organization (e.g., JSON, XML documents). Unstructured data is often rich in information but requires advanced tools, such as natural language processing and ML, to extract meaningful insights because it lacks a predefined structure or schema."
  },
  {
    "id": 103,
    "topic_id": 200,
    "title": "Understand the machine learning lifecycle.",
    "description": "ML is an iterative process, where models are continuously refined and improved based on new data and feedback, enabling the system to adapt and enhance its performance over time. The phases of the ML lifecycle are define ML problem, collect data, process data, choose algorithm, train model, evaluate model, deploy model, derive inference, and monitor model."
  },
  {
    "id": 104,
    "topic_id": 200,
    "title": "Know the difference between supervised, unsupervised, and reinforcement ML algorithms.",
    "description": "With supervised ML algorithms, models are trained to predict outcomes using labeled data, where each data point is tagged with a corresponding label or outcome (i.e., the correct prediction). In contrast, unsupervised ML algorithms work with unlabeled data. The objective is to identify hidden patterns, structures, or relationships within the data. Reinforcement ML algorithms force agents to learn how to predict outcomes through trial and error."
  },
  {
    "id": 105,
    "topic_id": 200,
    "title": "Know the difference between an ML algorithm and an ML model.",
    "description": "An ML algorithm is a set of rules or procedures used to create and train a model. It defines how the model will learn from the input data by adjusting its parameters. Examples include linear regression, logistic regression, decision trees, and k-Nearest Neighbors (k-NN). An ML model is the output generated after the training process using an ML algorithm. It represents the learned patterns and relationships derived from the training data. These patterns and relationships are codified in the form of a mathematical function, which essentially expresses in an unambiguous way the learned model. Once trained, the model can make predictions or classifications on new, unseen data."
  },
  {
    "id": 106,
    "topic_id": 200,
    "title": "Understand what a neural network is.",
    "description": "A neural network is a computational model used in DL that simulates the human brain, consisting of interconnected neurons in layers. It processes input data, adjusts weights and biases through learning algorithms, and produces output to recognize patterns and make predictions."
  },
  {
    "id": 107,
    "topic_id": 200,
    "title": "Know the difference between data ingestion and data storage.",
    "description": "Data ingestion is about aggregating data from different sources, whereas storage is about persisting data in a data store hosted in AWS."
  },
  {
    "id": 108,
    "topic_id": 200,
    "title": "Understand the different data formats.",
    "description": "CSV is used to store structured data in tabular format, whereas JSON is used for document-based, semi-structured data. Apache Parquet and Apache ORC are columnar data formats, whereas Apache Avro is a row-based format. RecordIO is a data format used primarily by Apache MXNet, a deep learning framework."
  },
  {
    "id": 109,
    "topic_id": 200,
    "title": "Understand ingestion services for streaming data.",
    "description": "These include Amazon Data Firehose, Amazon Kinesis Data Streams, Amazon MSK, and Amazon Streaming Service for Apache Flink. Amazon Kinesis Data Streams is more suited for real-time, custom data processing, whereas Amazon Data Firehose is ideal for efficiently loading streaming data into selected AWS data stores with minimal setup and management. Amazon MSK is best suited for managing and distributing streaming data (e.g., log aggregation, real-time analytics, and event sourcing), whereas Amazon Managed Service for Apache Flink is designed for processing and analyzing data in real time."
  },
  {
    "id": 110,
    "topic_id": 200,
    "title": "Understand ingestion services for data migration/batch/ETL data.",
    "description": "These include AWS DataSync and AWS Glue. The former is ideal for data transfer/migration of data into AWS and the latter for ETL and development of data pipelines."
  },
  {
    "id": 111,
    "topic_id": 200,
    "title": "Understand storage services for object data.",
    "description": "Amazon S3 is the most versatile and widely used object storage service on AWS. It provides industry-leading scalability, data availability, security, and performance. Object data contains the data itself, metadata, and a unique identifier. Object storage is accessed via APIs, making it suitable for cloud-native applications. Amazon S3 is natively supported by Amazon SageMaker as a data source for training ML models."
  },
  {
    "id": 112,
    "topic_id": 200,
    "title": "Understand storage services for file data.",
    "description": "Amazon EFS and the Amazon FSx family of services (Amazon FSx for Lustre, for NetApp ONTAP, for Windows File Server, and for OpenZFS) are used to store data as file storage type. File storage organizes data in a hierarchical manner and is ideal to persist shared data such as data in a company directory, media storage, and content management systems. Amazon EFS and Amazon FSx for Lustre are file-based storage services natively supported by Amazon SageMaker as data sources for training ML models."
  },
  {
    "id": 113,
    "topic_id": 200,
    "title": "Understand storage services for block data.",
    "description": "Amazon EBS is the block storage service on AWS. Block storage divides data into fixed-size blocks, each with a unique address but without metadata. Block storage delivers high performance and low latency, making it ideal for transactional workloads."
  },
  {
    "id": 114,
    "topic_id": 200,
    "title": "Understand storage services natively integrated with Amazon SageMaker.",
    "description": "Amazon SageMaker natively integrates with Amazon S3 for object storage, and Amazon EFS and Amazon FSx for Lustre for file system storage, facilitating seamless access to data for training, learning, and efficient management of ML workflows."
  },
  {
    "id": 115,
    "topic_id": 200,
    "title": "Know the feature engineering techniques that handle outliers.",
    "description": "To handle outliers in feature engineering, it’s essential to apply techniques that mitigate their impact on your ML model. These methods include removing outliers altogether (whenever possible) or transforming them using approaches such as logarithmic transformation, which can reduce the skewness of your data. Additionally, imputation methods such as replacing outliers with the median or mean value can be effective in maintaining the integrity of the dataset while reducing their impact on the resulting ML model."
  },
  {
    "id": 116,
    "topic_id": 200,
    "title": "Know the feature engineering techniques that handle skewness.",
    "description": "To handle skewness, techniques like logarithmic transformation, square root transformation, and Box-Cox or Yeo-Johnson transformations are excellent choices. These techniques can help normalize distributions and make them more suitable for statistical analysis, especially when dealing with skewed data where the majority of values are clustered toward one side of the distribution with a long tail on the other."
  },
  {
    "id": 117,
    "topic_id": 200,
    "title": "Know the feature engineering techniques that do not handle skewness.",
    "description": "Z-score standardization doesn’t directly address skewness. It scales the data to have a mean of 0 and a standard deviation of 1, but if the original data is skewed, it remains skewed after transformation. MinMax scaling doesn’t directly address skewness either. It resizes data to fit within a specific range, typically from 0 to 1, but doesn’t transform the data distribution. If your data is skewed, skewness remains even after scaling."
  },
  {
    "id": 118,
    "topic_id": 200,
    "title": "Know when to perform feature engineering with normalization versus standardization.",
    "description": "Normalization is useful when scale matters, whereas standardization is preferred when the distribution is key."
  },
  {
    "id": 119,
    "topic_id": 200,
    "title": "Know the feature engineering techniques that are used for standardization.",
    "description": "For standardization—whose purpose is to ensure that each feature in your dataset contributes equally to the ML model’s performance—consider using Z-score for normally distributed data."
  },
  {
    "id": 120,
    "topic_id": 200,
    "title": "Know the feature engineering techniques that are used for normalization.",
    "description": "For normalization—whose purpose is to scale each feature in your dataset to the same range (usually 0 to 1)—consider using the MinMax scaling technique."
  },
  {
    "id": 121,
    "topic_id": 200,
    "title": "Know the feature engineering techniques that are used for categorical data.",
    "description": "Use label encoding for categorical ordinal data and tree-based ML models. Use one-hot encoding for small sets of categorical, nominal data and non-tree-based ML models. Use binary encoding to reduce the dimensionality caused by one-hot-encoding techniques. Use feature hashing for high-cardinality categorical data, especially in use cases where compute resources need to be optimized and the solution must be cost-effective."
  },
  {
    "id": 122,
    "topic_id": 200,
    "title": "Know the feature engineering techniques that are used for image data.",
    "description": "For image data you can extract features from your raw dataset with Amazon SageMaker JumpStart. Amazon Rekognition is also a valid option for basic image analysis and feature extraction, depending on your use case. After extracting your relevant features from the dataset, you can leverage Amazon SageMaker Data Wrangler to transform your dataset for normalization and dimensionality reduction. Finally, you can store your features in Amazon SageMaker Feature Store."
  },
  {
    "id": 123,
    "topic_id": 200,
    "title": "Know the feature engineering techniques that are used for textual data.",
    "description": "For textual data, you can extract features from your raw dataset with Amazon Comprehend or Amazon Textract. For more customized feature extraction, Amazon SageMaker allows you to use tokenization, stemming, and lemmatization to perform basic selection of words or to reduce words to their root form for subsequent semantic analysis."
  },
  {
    "id": 124,
    "topic_id": 200,
    "title": "Know the AWS services that are used for data labeling.",
    "description": "For data labeling—whose purpose is to enrich your dataset with the actual predictions or meaningful metadata that helps your model to learn faster—consider using Amazon SageMaker Ground Truth."
  },
  {
    "id": 125,
    "topic_id": 200,
    "title": "Know how to manage class imbalance.",
    "description": "To mitigate the risks introduced by class imbalance, select a feature that is sensitive to bias (facet), and consider computing the pre-training bias metrics (provided by Amazon SageMaker Clarify) for that feature, such as Class Imbalance (CI) or Difference in Proportions of Labels (DPL). Determine the appropriate strategy accordingly. This can be data oversampling, undersampling, or class weighting."
  },
  {
    "id": 126,
    "topic_id": 200,
    "title": "Know the differences between training, validation, and test datasets.",
    "description": "The training dataset is where the model learns patterns, relationships, and features from the data. Essentially, it’s where the model gets its “education.” After the model has been trained, the validation dataset helps in adjusting hyperparameters and tuning the model to improve its performance and generalization to unseen data. It’s like a practice test before the final exam. The test dataset is used to evaluate the model’s overall performance. It provides an unbiased assessment of how well the model generalizes to new, unseen data. Think of it as the final exam that determines the model’s grade."
  },
  {
    "id": 127,
    "topic_id": 200,
    "title": "Know the AWS AI services for vision.",
    "description": "AWS offers two AI services tailored for vision-related tasks. Amazon Rekognition enables image and video analysis, allowing users to detect objects, faces, landmarks and text, as well as recognize celebrities and analyze sentiments. For document processing, Amazon Textract extracts text, tables, and other data from scanned documents, making it easier to digitize and manage document workflows efficiently."
  },
  {
    "id": 128,
    "topic_id": 200,
    "title": "Know the AWS AI services for speech and chatbots.",
    "description": "AWS provides two AI services for speech-related tasks. Amazon Polly delivers text-to-speech capabilities, transforming written content into natural-sounding speech in multiple languages. Amazon Transcribe offers automatic speech recognition (ASR), converting audio recordings into accurate text transcriptions. Amazon Lex enables the creation of conversational interfaces, combining ASR and natural language understanding (NLU) to power chatbots and voice assistants."
  },
  {
    "id": 129,
    "topic_id": 200,
    "title": "Know the AWS AI services for language.",
    "description": "AWS offers two AI services for language processing tasks. Amazon Comprehend enables natural language processing (NLP) by extracting insights from text, such as sentiment analysis, entity recognition, and key phrase extraction. Amazon Translate provides real-time and batch translation services, allowing for seamless multilingual communication."
  },
  {
    "id": 130,
    "topic_id": 200,
    "title": "Know the AWS AI services for generative AI.",
    "description": "AWS offers Amazon Bedrock, with a large selection of foundation models (FMs) including the newly released Nova FMs. Amazon Bedrock provides a robust platform for creating and deploying generative AI applications, allowing developers to build sophisticated solutions like text generation, image synthesis, embeddings, and more. These services empower users to leverage state-of-the-art generative AI models with ease, enabling innovative and creative applications across various domains."
  },
  {
    "id": 131,
    "topic_id": 200,
    "title": "Know the difference between classification and regression algorithms.",
    "description": "Classification algorithms are used to categorize data into distinct classes or labels, such as determining whether an email is spam. Regression algorithms, on the other hand, predict continuous numerical values, such as forecasting stock prices or estimating house values based on various features."
  },
  {
    "id": 132,
    "topic_id": 200,
    "title": "Know the linear learner algorithms provided by Amazon SageMaker.",
    "description": "Amazon SageMaker provides linear learner algorithms for both classification and regression tasks. These include Linear Regression, Logistic Regression, and Support Vector Machines. These algorithms are highly interpretable, making them ideal for applications where understanding the contribution of each feature to the predictions is critical."
  },
  {
    "id": 133,
    "topic_id": 200,
    "title": "Know the k-NN algorithm and when to use it.",
    "description": "The k-nearest neighbors algorithm is a simple yet powerful supervised ML algorithm for classification and regression tasks, where predictions are made based on the closest data points in the feature space. It is an Amazon SageMaker built-in algorithm, particularly useful when the decision boundary is complex and nonlinear, and when interpretability is important, as the reasoning behind each prediction is clear by examining the nearest neighbors. k-NN is best used with smaller datasets, due to its computational complexity, and in cases where you have a clear understanding of the data’s structure and relationships."
  },
  {
    "id": 134,
    "topic_id": 200,
    "title": "Know the decision tree supervised algorithms provided by Amazon SageMaker and when to use them.",
    "description": "Amazon SageMaker provides powerful decision-tree-based supervised algorithms like Random Forest and XGBoost. Random Forest is valuable for its ability to reduce overfitting and improve accuracy by creating an ensemble of decision trees and averaging their predictions, making it suitable for tasks that involve a large number of input features. XGBoost is known for its computational efficiency and performance, particularly with large datasets and complex models, and is often used for classification and regression tasks that require high predictive accuracy and speed."
  },
  {
    "id": 135,
    "topic_id": 200,
    "title": "Know the clustering algorithms provided by Amazon SageMaker.",
    "description": "Amazon SageMaker provides the unsupervised K-Means algorithm for clustering, which is not be confused with the supervised k-NN algorithm intended for classification and regression tasks."
  },
  {
    "id": 136,
    "topic_id": 200,
    "title": "Know the dimensionality reduction algorithms provided by Amazon SageMaker.",
    "description": "Amazon SageMaker provides the unsupervised Principal Component Analysis algorithm for dimensionality reduction, which is useful for reducing the number of features in a dataset while retaining as much variability as possible."
  },
  {
    "id": 137,
    "topic_id": 200,
    "title": "Know the topic modeling algorithms provided by Amazon SageMaker.",
    "description": "Amazon SageMaker provides the unsupervised Latent Dirichlet Allocation and Neural Topic Model algorithms for topic modeling use cases, enabling users to discover hidden topics in large collections of textual data without the need for labeled data."
  },
  {
    "id": 138,
    "topic_id": 200,
    "title": "Know the anomaly detection algorithms provided by Amazon SageMaker.",
    "description": "Amazon SageMaker provides the unsupervised Random Cut Forest and IP Insights algorithms for anomaly detection use cases, which are particularly useful for identifying unusual patterns or behaviors in data, such as detecting fraudulent activities or network intrusions."
  },
  {
    "id": 139,
    "topic_id": 200,
    "title": "Know the textual analysis algorithms provided by Amazon SageMaker.",
    "description": "Amazon SageMaker provides the BlazingText and Sequence-to-Sequence algorithms for textual analysis use cases, enabling efficient handling of large-scale textual data and supporting various natural language processing tasks such as text classification, translation, and summarization."
  },
  {
    "id": 140,
    "topic_id": 200,
    "title": "Know the image processing algorithms provided by Amazon SageMaker.",
    "description": "Amazon SageMaker provides the Image Classification, Object Detection, and Semantic Segmentation algorithms for image processing use cases, enabling developers to build, train, and deploy machine learning models that can analyze and understand visual data, such as recognizing objects, classifying images into categories, and segmenting images at the pixel level for detailed analysis."
  },
  {
    "id": 141,
    "topic_id": 200,
    "title": "Know the difference between local, remote, and distributed training.",
    "description": "Local training involves training a machine learning model on a single machine using its available resources. Remote training, on the other hand, runs the training process on a cloud service (e.g., Amazon SageMaker) or remote server, leveraging external compute resources without overloading the local system. Distributed training involves spreading the training workload across multiple machines or nodes, either locally or remotely, to handle larger datasets and reduce training time by parallelizing the computations."
  },
  {
    "id": 142,
    "topic_id": 200,
    "title": "Know the difference between model parameters and hyperparameters.",
    "description": "Model parameters are the internal configurations that a machine learning model learns from the training data, such as the weights in a neural network or the coefficients in a linear regression model. These parameters are adjusted during the training process to minimize the error, also known as the loss function, and improve the model’s performance. On the other hand, hyperparameters are external settings that control the overall behavior of the learning algorithm, such as the learning rate, the number of trees in a random forest, or the number of layers in a neural network. Hyperparameters are set before training begins and are typically tuned during evaluation through methods like grid search, random search, or Bayesian search to optimize the model’s performance."
  },
  {
    "id": 143,
    "topic_id": 200,
    "title": "Know the main evaluation metrics for classification problems.",
    "description": "For classification problems, the main evaluation metrics include accuracy, precision, recall, F1 score, and AUC-ROC. Accuracy measures the proportion of correctly classified instances out of the total instances. Precision evaluates the proportion of true positive predictions among all positive predictions, reflecting the quality of positive predictions. Recall (or sensitivity) measures the proportion of true positive predictions among all actual positives, indicating the model’s ability to identify positive instances. The F1 score is the harmonic mean of precision and recall, providing a balanced measure that considers both false positives and false negatives. Area under the curve–receiver operating characteristic assesses the model’s ability to discriminate between classes by plotting the true positive rate against the false positive rate across different threshold settings."
  },
  {
    "id": 144,
    "topic_id": 200,
    "title": "Know the main evaluation metrics for regression problems.",
    "description": "For regression problems, the main evaluation metrics include mean squared error (MSE), root mean squared error (RMSE), mean absolute error (MAE), mean absolute percentage error (MAPE), and R-squared (R²). MSE calculates the average of the squared differences between predicted and actual values, highlighting significant discrepancies. RMSE, the square root of MSE, provides error metrics in the same units as the target variable, making it easier to interpret. MAE measures the average magnitude of the absolute errors, offering a straightforward interpretation of prediction accuracy. MAPE provides a percentage-based evaluation of errors, useful for comparing models across different datasets. R² indicates the proportion of variance in the target variable predictable from the features, with values closer to 1 implying better model performance."
  },
  {
    "id": 145,
    "topic_id": 200,
    "title": "Know the difference between Bayesian search and other hyperparameter tuning techniques.",
    "description": "Bayesian search is a hyperparameter optimization (HPO) technique that uses Bayesian inference to model the relationship between hyperparameters and the objective function, guiding the search for optimal hyperparameters based on prior knowledge and past evaluations. The objective function is a metric or measure that the optimization process aims to maximize or minimize, such as accuracy, loss, or other performance metrics. Unlike other HPO techniques such as grid search, which exhaustively searches a predefined space, or random search, which samples hyperparameters randomly, Bayesian search intelligently selects the next set of hyperparameters to evaluate by predicting their performance, thereby improving efficiency and often requiring fewer evaluations to find the best configuration. This makes Bayesian search particularly effective for complex models with large hyperparameter spaces. We used Bayesian search in our deep dive example to efficiently optimize our XGBoost model on the Digits dataset with Amazon SageMaker AI Automatic Model Tuning."
  },
  {
    "id": 146,
    "topic_id": 200,
    "title": "Understand the difference between underfitting and overfitting as well as the methods to address them.",
    "description": "Underfitting occurs when a model is too simple to capture the underlying patterns in the data, resulting in poor performance on both the training and test datasets. Overfitting, on the other hand, happens when a model is too complex and captures noise or random fluctuations in the training data, leading to excellent performance on the training dataset but poor generalization to new, unseen data. To address underfitting, we can increase the model’s complexity by adding more features, using a more sophisticated algorithm, or extending the training duration. To overcome overfitting, techniques such as K-fold cross-validation, pruning, regularization (e.g., L1, L2, Elastic Net), and data augmentation can be employed. These methods help strike a balance between model complexity and generalization, improving overall performance."
  },
  {
    "id": 147,
    "topic_id": 200,
    "title": "Understand the use of K-fold cross-validation and its benefits.",
    "description": "K-fold cross-validation involves partitioning the dataset into k equally-sized folds or subsets. The model is then trained on k – 1 folds and tested on the remaining fold. This process is repeated k times, each time using a different fold as the test set, and the results are averaged to provide a comprehensive evaluation of the model’s performance. This approach helps mitigate the bias and variance issues associated with a single train-test split by ensuring that every data point is used for both training and validation. Compared to methods like a single-holdout validation or random train-test split, K-fold cross-validation provides a more accurate and reliable assessment of the model’s ability to generalize to unseen data, making it particularly useful for small or imbalanced datasets."
  },
  {
    "id": 148,
    "topic_id": 200,
    "title": "Know the difference between inference infrastructure and training infrastructure.",
    "description": "Inference infrastructure generally requires significantly less compute and memory than training infrastructure because inference only involves applying a pretrained model to new data, whereas training involves the computationally intensive process of learning and optimizing the model parameters from a large dataset."
  },
  {
    "id": 149,
    "topic_id": 200,
    "title": "Know Amazon SageMaker AI’s managed deployment options.",
    "description": "Amazon SageMaker AI offers four managed deployment options to cater to diverse use cases. Real-time inference provides low-latency endpoints for immediate predictions, perfect for interactive applications. Serverless inference automatically scales resources based on traffic, ideal for applications with intermittent or unpredictable patterns. Asynchronous inference handles large payloads and long processing times efficiently, making it suitable for heavy workloads. Batch inference processes large datasets in bulk, ideal for non-real-time predictions. These options ensure flexibility, scalability, and efficiency, allowing you to choose the best approach for your specific use case."
  },
  {
    "id": 150,
    "topic_id": 200,
    "title": "Know when to use multi-model endpoints (MMEs) vs. multi-container endpoints (MCEs).",
    "description": "Use MMEs to host multiple models within the same container on a single endpoint when you have many models with low traffic volume and want to save on costs by sharing resources. Use MCEs to host different models in separate containers on a single endpoint when each model has distinct dependencies and resource requirements and you need better isolation and scalability for independent updates."
  },
  {
    "id": 151,
    "topic_id": 200,
    "title": "Know when to use CPU- vs. GPU-powered infrastructure.",
    "description": "Use GPU-powered infrastructure for compute-intensive jobs to train deep learning models with large amounts of data. Use CPU-powered infrastructure for tasks that don’t require the massive parallel processing capabilities of GPUs. These tasks include preprocessing data, performing feature engineering, running smaller training jobs, and handling inference tasks where the computational demands are lower."
  },
  {
    "id": 152,
    "topic_id": 200,
    "title": "Know the autoscaling metrics for Amazon SageMaker AI endpoints.",
    "description": "Autoscaling metrics include InvocationsPerInstance , which measures the average number of invocations per instance per minute; CPUUtilization , tracking the percentage of CPU usage; Latency , measuring the time taken to process requests; and GPUUtilization , which measures the percentage of GPU usage. These metrics help create scaling policies to automatically adjust the number of instances, ensuring optimal performance and cost-efficiency."
  },
  {
    "id": 153,
    "topic_id": 200,
    "title": "Know when to use All At Once, Canary, and Linear traffic-shifting patterns with Blue/Green deployments.",
    "description": "Use the All At Once traffic-shifting pattern for Blue/Green deployments when you have high confidence in the new version of your model and want a quick transition. Choose the Canary pattern when you want to minimize risk by gradually shifting a small portion of traffic (Canary) to the new version and monitoring its performance before a full rollout. Choose the Linear pattern for a controlled, step-by-step traffic shift, providing the most balanced approach that allows for incremental monitoring and adjustments."
  },
  {
    "id": 154,
    "topic_id": 200,
    "title": "Know the different ML workflow orchestration services available with AWS and when to use them.",
    "description": "AWS offers several ML workflow orchestration services to streamline and manage ML pipelines: Amazon SageMaker Pipelines for automating end-to-end ML workflows, perfect for managing the entire ML lifecycle; AWS Step Functions for coordinating complex workflows with multiple steps, ideal for integrating with other AWS services and handling error recovery; and Amazon Managed Workflows for Apache Airflow (MWAA) for managing Apache Airflow workflows in a fully managed environment, suitable for orchestrating complex workflows like ETL jobs or ML pipelines with minimal operational overhead."
  },
  {
    "id": 155,
    "topic_id": 200,
    "title": "Know the types of model monitoring provided by Amazon SageMaker Model Monitor.",
    "description": "There are four types of model monitoring. The first is data quality monitoring, which checks for anomalies in the input data. The second is model quality monitoring, which tracks performance metrics like accuracy and precision. The third is bias drift monitoring, which ensures that the model remains unbiased. The fourth is feature attribution drift monitoring, which observes changes in the importance of features."
  },
  {
    "id": 156,
    "topic_id": 200,
    "title": "Know when baselining is performed in the monitoring workflow.",
    "description": "Baselining is performed at the very beginning of model development, before training any complex models, to establish a reference point against which the performance of more advanced models can be measured and compared."
  },
  {
    "id": 157,
    "topic_id": 200,
    "title": "Know the services that detect data quality monitoring.",
    "description": "Amazon SageMaker Model Monitor uses the constraints in the model baseline to detect data drift such as the standard deviation of feature values or the rate of missing values in your input data. When Amazon CloudWatch detects that these metrics deviate significantly from the established baseline, it can trigger alerts, enabling you to take timely corrective actions. Additionally, Amazon SageMaker Data Wrangler can be used to simplify data preparation and profiling, whereas Amazon SageMaker Feature Store can store and maintain consistent feature availability. Together, these services provide robust data quality monitoring throughout the ML lifecycle."
  },
  {
    "id": 158,
    "topic_id": 200,
    "title": "Know the services that detect model quality monitoring.",
    "description": "Amazon SageMaker Model Monitor continuously tracks your model’s key performance metrics and alerts you of any deviations, ensuring that model performance remains high. Amazon SageMaker Clarify detects bias and explains model predictions, ensuring fairness and transparency. Amazon CloudWatch monitors custom metrics related to model performance and sets up alarms for significant changes that can trigger corrective actions, such as updating training data, updating the model’s parameters, and retraining the model. Together, these services provide robust model quality monitoring throughout the ML lifecycle."
  },
  {
    "id": 159,
    "topic_id": 200,
    "title": "Know the pillars of the Machine Learning Well-Architected Lens specific to the Monitoring ML lifecycle phase.",
    "description": "The pillars of the Machine Learning Well-Architected Lens specific to the Monitoring ML lifecycle phase are operational excellence, security, reliability, performance efficiency, cost optimization, and sustainability"
  },
  {
    "id": 160,
    "topic_id": 200,
    "title": "Know the difference between Amazon CloudWatch and Amazon EventBridge.",
    "description": "Amazon CloudWatch focuses on monitoring and managing AWS resources by collecting metrics, logs, and events and providing actionable insights with alarms. Amazon EventBridge, on the other hand, is an event bus that routes events from various sources to targets, enabling event-driven architectures. In summary, Amazon CloudWatch is primarily for monitoring, whereas Amazon EventBridge is for routing and reacting to events across your AWS environment."
  },
  {
    "id": 161,
    "topic_id": 200,
    "title": "Know the AWS services to track and optimize cost.",
    "description": "AWS Cost Explorer provides a comprehensive view of your AWS spending and usage, allowing you to analyze and forecast costs with visualizations and custom reports. You can set custom budgets and receive alerts with AWS Budgets, ensuring you stay within your defined spending limits. AWS Trusted Advisor offers best practice recommendations to optimize your AWS resources, improve performance, and reduce costs. For detailed billing data, AWS Cost and Usage Report (CUR) delivers insights into your spending patterns over time. Lastly, AWS Savings Plans provide discounted pricing by committing to a consistent usage level over a one- or three-year term, helping you save money on your AWS costs."
  },
  {
    "id": 162,
    "topic_id": 200,
    "title": "Know the difference between IAM users, IAM roles, and IAM groups.",
    "description": "An IAM user is an AWS identity that represents an individual person or service that interacts with AWS resources. IAM users have long-term credentials like passwords or access keys. IAM roles are identities that can be assumed by IAM users or other roles and use temporary security tokens for access. This makes them ideal for granting temporary permissions to identities such as applications or users that need to assume different sets of permissions. Lastly, IAM groups are identities representing collections of IAM users that share common permissions."
  },
  {
    "id": 163,
    "topic_id": 200,
    "title": "Know the elements of an AWS access policy.",
    "description": "An AWS access policy is a JSON document that defines permissions for an IAM identity (IAM user, IAM group, or IAM role) or an AWS resource. The main elements of an access policy include Version , which specifies the policy language version; Statement , which contains one or more individual permissions; Effect , which can be either Allow or Deny to grant or restrict access; Action , which specifies the API operations allowed or denied; Resource , which specifies the AWS resources to which the actions apply; and Condition , which optionally specifies the conditions under which the policy is in effect. Together, these elements outline what actions are permitted or denied for specified resources under defined conditions."
  },
  {
    "id": 164,
    "topic_id": 200,
    "title": "Know the different access policy types.",
    "description": "Identity-based policies are attached directly to IAM users, IAM groups, or IAM roles and define what actions they can perform on which resources. Resource-based policies are attached to AWS resources like Amazon S3 buckets and specify who can access those resources and what actions they can take. Permissions boundaries are advanced policies that set the maximum permissions an identity-based policy can grant to an IAM user or IAM role. Service Control Policies (SCPs) are used within AWS Organizations to manage permissions across all accounts and organizational units, defining what actions can be performed by the accounts’ users and roles."
  },
  {
    "id": 165,
    "topic_id": 200,
    "title": "Know what Amazon SageMaker Role Manager is.",
    "description": "Amazon SageMaker Role Manager is a tool that simplifies the creation and management of IAM roles tailored for ML workflows. It allows ML administrators to define persona-based roles with predefined permissions for common ML activities. Personas include Data Scientist, MLOps, and SageMaker AI Compute. With Amazon SageMaker Role Manager, you can ensure least privilege access, granting only the necessary permissions for specific tasks. This helps streamline security management and ensures that different users have appropriate access levels for their roles within Amazon SageMaker AI."
  },
  {
    "id": 166,
    "topic_id": 200,
    "title": "Know the difference between NACLs and security groups.",
    "description": "Network access control lists are stateless firewalls that control traffic at the subnet level, allowing or denying traffic based on IP address, protocol, and port. With NACLs, both inbound and outbound rules must be defined. Security groups, on the other hand, are stateful firewalls that control traffic at the instance level, allowing traffic based on IP address, protocol, and port. Due to their stateful nature, security groups always return traffic automatically."
  },
  {
    "id": 167,
    "topic_id": 200,
    "title": "Know the ways to implement private connectivity in a VPC.",
    "description": "Private connectivity in an AWS VPC can be implemented using VPC endpoints, which enable secure, private connections between your VPC and supported AWS services without traversing the public Internet. There are two types of VPC endpoints: interface endpoints and gateway endpoints. Interface endpoints use AWS PrivateLink to provide private access to services such as Amazon S3, Amazon SageMaker AI, and Amazon EC2 through an elastic network interface within your VPC. Gateway endpoints provide private connectivity to services like Amazon S3 and Amazon DynamoDB by adding route entries to your VPC route tables. By using these endpoints, you can ensure that your data traffic remains secure and private within the AWS network."
  }
];
